import { useEffect } from 'react';
import { ListSkeleton, PanelSkeleton } from '@/components/ui/skeleton';
import { RoleList } from './RoleList';
import { PermissionsPanel } from './PermissionsPanel';
import { PermissionHistoryModal } from './PermissionHistoryModal';
import { useAuthorizationStore } from '../store';

export function RoleAuthorizationsPanel() {
  const {
    roles,
    permissionsByModule,
    selectedRoleForAuth,
    isLoadingRoles,
    isLoadingPermissions,
    fetchRoles,
    fetchPermissions,
    selectRoleForAuth,
    openPermissionHistoryModal,
  } = useAuthorizationStore();

  useEffect(() => {
    fetchRoles();
    fetchPermissions();
  }, [fetchRoles, fetchPermissions]);

  if (isLoadingRoles || isLoadingPermissions) {
    return (
      <div className="flex h-[calc(100vh-16rem)] border rounded-lg overflow-hidden">
        <div className="w-72 border-r bg-muted/20 flex-shrink-0 p-4">
          <ListSkeleton rows={8} />
        </div>
        <div className="flex-1 bg-background p-4">
          <PanelSkeleton rows={8} className="border-0 p-0" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-[calc(100vh-16rem)] border rounded-lg overflow-hidden">
      {/* Left Panel - Role List */}
      <div className="w-72 border-r bg-muted/20 flex-shrink-0">
        <RoleList
          roles={roles}
          selectedRole={selectedRoleForAuth}
          onSelectRole={selectRoleForAuth}
        />
      </div>

      {/* Right Panel - Permissions */}
      <div className="flex-1 bg-background">
        {selectedRoleForAuth ? (
          <PermissionsPanel
            role={selectedRoleForAuth}
            permissionsByModule={permissionsByModule}
            onOpenHistory={openPermissionHistoryModal}
            readOnly={selectedRoleForAuth.isSystemRole}
          />
        ) : (
          <div className="flex items-center justify-center h-full text-muted-foreground">
            <div className="text-center">
              <p className="text-lg font-medium">Select a role</p>
              <p className="text-sm mt-1">
                Choose a role from the list to view and edit its permissions
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Permission History Modal */}
      <PermissionHistoryModal />
    </div>
  );
}
